/* MS2 — adicionar ao carrinho a partir do card (carrossel e página de coleção).
   Mesmo caminho da PDP: /cart/add.js + Section Rendering API, atualiza o drawer
   e a bolinha do header, e abre o drawer sem sair da página.
   Se qualquer coisa falhar, cai no POST normal do formulário. */
(function () {
  function parse(html, sel) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return (doc.querySelector(sel) || doc.body).innerHTML;
  }

  function onSubmit(e) {
    var form = e.target.closest('[data-ms2-card-form]');
    if (!form) return;

    var drawerEl = document.querySelector('cart-drawer');
    if (!drawerEl) return; // sem drawer, deixa o POST normal seguir

    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    var textoOriginal = btn ? btn.textContent : '';
    if (btn) { btn.setAttribute('disabled', ''); btn.textContent = 'Adicionando…'; }

    var fd = new FormData(form);
    fd.append('sections', 'cart-drawer,cart-icon-bubble');
    fd.append('sections_url', window.location.pathname);

    fetch('/cart/add.js', {
      method: 'POST', body: fd, headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state.status) { form.submit(); return; } // erro da API → POST normal

        var inner = document.getElementById('CartDrawer');
        if (inner && state.sections && state.sections['cart-drawer']) {
          inner.innerHTML = parse(state.sections['cart-drawer'], '#CartDrawer');
        }
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && state.sections && state.sections['cart-icon-bubble']) {
          bubble.innerHTML = parse(state.sections['cart-icon-bubble'], '.shopify-section');
        }
        drawerEl.classList.remove('is-empty');
        var di = drawerEl.querySelector('.drawer__inner');
        if (di) di.classList.remove('is-empty');
        var ov = drawerEl.querySelector('#CartDrawer-Overlay');
        if (ov) ov.addEventListener('click', function () { drawerEl.close(); });
        if (typeof drawerEl.open === 'function') drawerEl.open();
      })
      .catch(function () { form.submit(); })
      .finally(function () {
        if (btn) { btn.removeAttribute('disabled'); btn.textContent = textoOriginal; }
      });
  }

  // delegação no documento: pega cards de qualquer seção, inclusive as
  // recarregadas pelo editor de tema.
  document.addEventListener('submit', onSubmit);
})();
